module.exports = __webpack_public_path__ + "static/media/Inter-Medium.000899d4.woff2";